export enum OverviewTab {
	POSITIONS = 'positions',
	ORDERS = 'orders',
	BALANCES = 'balances',
}

export enum MarketTab {
	WATCHLIST = 'Watchlist',
	TOP_GAINERS = 'Top Gainers',
	TOP_LOSERS = 'Top Losers',
}
